module.exports = __webpack_public_path__ + "fire.ba68bd50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/fire.png
// module id = 317
// module chunks = 0